import { useEffect, useState } from "react";
export default function useFetch(fetchFn) {
  const [data, setData] = useState([]);
  const [dbError, setDbError] = useState();
  const [isLoading, setIsLoading] = useState(false);
  const [loadingText, setLoadingText] = useState("");

  useEffect(() => {
    
    async function fetchData() {
      console.log("fetching data here....");
        setIsLoading(true);
        setLoadingText("loading page, please wait...");

        try{
            const response = await fetchFn();
            setIsLoading(false);
            setData(response.data);
        }
        catch(error){
            setDbError(error.message || 'Failed to fetch data');
        }
        setIsLoading(false);
    }
    fetchData();
  }, [fetchFn]);

  return { data, dbError, isLoading, loadingText, setIsLoading, setLoadingText };
}
